import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import { ValidateFilterValue } from './ValidateControl';

export function NotValidatedCheckboxIcon({disabled = false}: {disabled?: boolean}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            style={{backgroundColor: disabled ? 'rgb(240, 240, 240)' : 'transparent'}}
            viewBox="0 0 16 16"
        >
            <path
                color={false ? 'rgb(200, 200, 200)' : 'rgb(255, 147, 69)'}
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
        </svg>
    );
}

export function ValidatedCheckboxIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path
                color="rgb(130, 240, 130)"
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
                color="rgb(60, 220, 60)"
                d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
            />
        </svg>
    );
}

const Label = styled.label`
    height: 18px;
`;

const HiddenCheckbox = styled.input`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
`;

function getTooltipMessage(visible: boolean, disabled: boolean) {
    if (disabled) return 'All validation issues must be fixed before marking this as visible';
    return visible ? 'Mark as not visible' : 'Mark as visible';
}

export function VisibilityControl(props) {
    const message = getTooltipMessage(props.visible, props.disabled);

    return (
        <Tippy content={message}>
            <Label>
                <HiddenCheckbox
                    type="checkbox"
                    checked={props.validated}
                    disabled={props.disabled}
                    onChange={(e) => props.onChange({validated: e.target.checked})}
                />
                {props.validated ? (
                    <ValidatedCheckboxIcon />
                ) : (
                    <NotValidatedCheckboxIcon disabled={props.disabled} />
                )}
            </Label>
        </Tippy>
    );
}

const StyledValidatedIcon = styled.span`
    line-height: 1;
    vertical-align: bottom;
`;

export function ValidatedIcon() {
    return (
        <StyledValidatedIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
            >
                <path
                    color="rgb(60, 220, 60)"
                    d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
                />
            </svg>
        </StyledValidatedIcon>
    );
}

export function VisibilityIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16">
            <path
                color="rgb(130, 240, 130)"
                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8m-8 3.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
            />
            <path color="rgb(60, 220, 60)" d="M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        </svg>
    );
}

export function NoVisibilityIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16">
            <path
                color="rgb(180, 180, 180)"
                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8m-8 3.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7"
            />
            <path color="rgb(150, 150, 150)" d="M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
            <path
                d="M2 2l12 12"
                stroke="rgb(150, 150, 150)"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}

function NotFilteredCheckboxIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path
                color="rgb(200, 200, 200)"
                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            />
            <path
                color="rgb(200, 200, 200)"
                d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"
            />
        </svg>
    );
}

export enum VisibleFilterValue {
    Unset = 1,
    Visible = 2,
    NotVisible = 3
}

const FilterContainer = styled.span`
    height: 18px;
    font-size: 18px;
    line-height: 1;
    // vertical-align: bottom;
`;

export function ValidateFilter({
    value,
    onChange
}: {
    value: VisibleFilterValue;
    onChange: ({value}) => void;
}) {
    function message() {
        switch (value) {
            case VisibleFilterValue.Unset:
                return 'Showing visible and not visible';
            case VisibleFilterValue.Visible:
                return 'Showing visible';
            case VisibleFilterValue.NotVisible:
                return 'Showing not visible';
            default:
                return null;
        }
    }

    function icon() {
        switch (value) {
            case VisibleFilterValue.Unset:
                return <NotFilteredCheckboxIcon />;
            case VisibleFilterValue.Visible:
                return <ValidatedCheckboxIcon />;
            case VisibleFilterValue.NotVisible:
                return <NotValidatedCheckboxIcon />;
            default:
                return null;
        }
    }

    function nextValue() {
        switch (value) {
            case VisibleFilterValue.Unset:
                return VisibleFilterValue.Visible;
            case VisibleFilterValue.Visible:
                return VisibleFilterValue.NotVisible;
            case VisibleFilterValue.NotVisible:
                return VisibleFilterValue.Unset;
            default:
                return null;
        }
    }

    return (
        <Tippy content={message()}>
            <FilterContainer onClick={() => onChange({value: nextValue()})}>
                {icon()}
            </FilterContainer>
        </Tippy>
    );
}
